// @ts-nocheck

import { useContext } from "react";
import { UserContext } from "../../Providers/UserProvider";
import contentMap from "./linkMap.json";
import { Link } from "react-router-dom";

/*
interface AccessMapInterface {
  AccessMap: Record<string, { access: string[] }>;
  Modules: Record<string, { name: string; linkTo: string; icon?: string }>;
}*/

const DrawerContent = () => {
  const { userSession } = useContext(UserContext);

  return (
    <div>
      <div className="mt-3">
        <div className="pb-4"></div>
        <div>
          {userSession?.claims?.roles.length > 0 &&
            userSession?.claims.roles.map((item: string) => {
              return (
                <div key={item}>
                  <span
                    className={`bg-neutral  py-1 w-full border flex  shadow-sm  text-secondary font-bold pl-2 ${
                      item === "User" ? "hidden" : ""
                    }`}
                  >
                    {item === "Jobber" ? "Agent" : item} Options
                  </span>
                  {contentMap.AccessMap[item].access.map((area, index2) => {
                    return (
                      <Link to={contentMap.Modules[area].linkTo} key={index2}>
                        <div className="border-t-2 py-5 pl-4 text-slate-600 hover:text-accent">
                          {contentMap.Modules[area].name}
                        </div>
                      </Link>
                    );
                  })}
                  <div className=" py-4" />
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default DrawerContent;
